import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import PageLoader from "./PageLoader";
import { Outlet, useLocation } from "react-router-dom";

const FontLayout = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const isLoginPage = location.pathname === "/login";

    return (
        <>
            <style>{`
        .font-app {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .font-content {
          flex: 1;
          padding: 0px;
        }
      `}</style>

            <div className="font-app">
                {!isLoginPage && <Header />}

                <div className="font-content">
                    {loading && <PageLoader />}
                    <Outlet context={{ setLoading }} />
                </div>

                {!isLoginPage && <Footer />}
            </div>
        </>
    );
};

export default FontLayout;